export default "__VITE_ASSET__DkZqjls5__"